import { MobileRouterPaths } from "../mobileAppConstants.js";
import { useLocation } from "react-router";
import { Fragment, useCallback } from "react";
import { MobileMenuFixedStyled, MobileMenuItemStyled, MobileMenuStyled } from "./styled/MobileMenuStyled.js";
import { BinIcon } from "../../components/icon/Icon.jsx";
import { Link } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import {
    getUserSelectedAccountType,
    makeSelectAppLoggedIn
} from "../../app/appSelectors.js";
import { logAppsflyerAction } from "../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../app/appConstants";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";

const mobileMenu = [{
    to: MobileRouterPaths.portfolio,
    icon: 'IcPortfolio',
    title: 'lite_version.home.title'
}, {
    to: MobileRouterPaths.market,
    icon: 'IcChartStatistic',
    title: 'lite_version.home.market'
}, {
    to: MobileRouterPaths.profile,
    icon: 'IcPerson',
    title: 'lite_version.home.profile',
}];

function MobileMenu(props) {
    const {isLoggedIn, logAppsflyer, selectedAccountType} = props;
    const {pathname} = useLocation();
    const {getLangPath} = useLangContext();

    const handleClick = useCallback((e) => {
        const to = e.currentTarget.dataset.to;
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.APP_TAB_CLICK,
            payload: {
                account_type: selectedAccountType,
                current_tab: pathname,
                new_tab: to,
            }
        });
    }, [logAppsflyer, pathname, selectedAccountType]);

    if (!isLoggedIn) {
        return null;
    }

    return <MobileMenuFixedStyled>
        <MobileMenuStyled>
            {
                mobileMenu.map(item => <Fragment key={item.to}>
                    <MobileMenuItemStyled
                        className={item.to === pathname ? 'active' : ''}
                        data-to={item.to}
                        onClick={handleClick}
                    >
                        <Link to={item.to}>
                            <BinIcon name={item.icon}/>
                            <div className={'title'}>{getLangPath(item.title)}</div>
                        </Link>
                    </MobileMenuItemStyled>
                </Fragment>)
            }
        </MobileMenuStyled>
    </MobileMenuFixedStyled>
}

const mapStateToProps = createStructuredSelector({
    isLoggedIn: makeSelectAppLoggedIn(),
    selectedAccountType: getUserSelectedAccountType,
});

const mapDispatchToProps = (dispatch) => ({
    logAppsflyer: payload => dispatch(logAppsflyerAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu);
